export const generatedHtmlFileCustomer = (load) => {
	const generateFileSection = (title, files) =>
		files && files.length > 0
			? `<div style="margin-bottom: 20px;">
        <h3 style="font-family: Arial, sans-serif; color: #333;">${title}</h3>
        <ul style="list-style: square;">
          ${files
						.map(
							(file) => `
            <li>
              <a style="display:inline-block;margin-bottom: 4px;border-radius:8px;background-color:#1595e7;padding:6px 10px;font-family:Arial, sans-serif;font-weight:bold;font-size:12px;color:#ffffff;text-decoration:none;" href="${file.location}" target="_blank">
                ${file.originalname}
              </a>
            </li>
          `
						)
						.join("")}
        </ul>
      </div>`
			: "";

	return `<table style="table-layout:fixed;min-width:600px;background-color:#f4f4f4" bgcolor="#f4f4f4" width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
    <tbody>
      <tr>
        <td align="center" valign="top">
          <table style="width:600px;max-width:600px" width="600" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation">
            <tbody>
              <tr>
                <td style="padding:20px 0px 20px 0px" align="left" valign="top">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="width:100%">
                    <tbody>
                      <tr>
                        <td valign="top">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
                            <tbody>
                              <tr>
                                <td style="padding:0px 0px 0px 0px">
                                  <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
                                    <tbody>
                                      <tr>
                                        <td valign="top" style="background-size:cover;background-position:center;background-repeat:no-repeat;padding:36px 40px 36px 40px;border-radius:0px;background-color:transparent" bgcolor="transparent" background="https://ci3.googleusercontent.com/meips/ADKq_NYEuJeWS3M0gulaXrf1-FqCG73kj2NuhBV-8E5dfZbapTKSyWfK2M7PIaeLNBC2iy6b9fDU8XjadLj4Rxj4TrhuctUtbrAG657_fI-DzgBk=s0-d-e1-ft#https://cloudfilesdm.com/postcards/image-1713281331227.png">
                                          <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                                            <tbody>
                                              <tr>
                                                <td align="center" valign="top" style="padding:0px 0px 0px 0px">
                                                  <img src="https://ci3.googleusercontent.com/meips/ADKq_Nbw8_IkgGAqBqvkc9OvwwAEXiTFh2ILLL5p6c-eszM4NGSUY8wECvvzInP6nCPYZVtld75z6JCJKS3cpKcOdDBxrfM-rlZ-mH04jWq_NG_c=s0-d-e1-ft#https://cloudfilesdm.com/postcards/image-1713281317060.png" width="196" height="63" alt="" style="display:block;border:0;outline:0;line-height:100%;width:196px;height:auto;max-width:100%" class="CToWUd" data-bit="iit">
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td valign="top">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
                            <tbody>
                              <tr>
                                <td style="padding:0px 0px 0px 0px">
                                  <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
                                    <tbody>
                                      <tr>
                                        <td valign="top" style="padding:15px 40px 0px 40px;border-radius:0px;background-color:#ffffff" bgcolor="#ffffff">
                                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse:separate;border-spacing:0">
                                            <tbody>
                                              <tr>
                                                <td valign="top" align="center" style="padding:0px 0px 0px 0px">
                                                  <div style="line-height:166%;letter-spacing:-0.5px;font-family:Fira Sans,Arial,Helvetica,sans-serif;font-size:19px;font-weight:500;font-variant-ligatures:normal;color:#434343;text-transform:uppercase;text-decoration:underline;text-align:center;text-align-last:center">
                                                    <div><span style="font-weight:400;font-style:normal;color:rgb(31,31,31)"> ${
																											load.pickUpList[0].pickUpLocation
																										} -- ${
		load.destinationList[0].destination
	} </span></div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>

                   

                       <tr style="background-color: white;">
                        <td valign="top">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="padding: 10px 22px;">
                            <tbody>
                              <tr>
                                <td style="padding:0px 0px 0px 0px">
                                  <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
                                    <tbody>
                                    ${generateFileSection("Proof of Delivery (POD)", load.PODFiles)}
                                    ${generateFileSection("Bill of Lading (BOL)", load.BOLFiles)}
                                    ${generateFileSection(
																			"Rate Confirmation (RateCON)",
																			load.rateCONFiles
																		)}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>

  
                
                      <tr>
                        <td valign="top">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
                            <tbody>
                              <tr>
                                <td style="padding:0px 0px 0px 0px">
                                  <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                                    <tbody>
                                      <tr>
                                        <td valign="top" style="background-size:cover;background-position:center;background-repeat:no-repeat;padding:40px 40px 40px 40px;border-radius:0px;background-color:transparent" bgcolor="transparent" background="https://ci3.googleusercontent.com/meips/ADKq_NYEuJeWS3M0gulaXrf1-FqCG73kj2NuhBV-8E5dfZbapTKSyWfK2M7PIaeLNBC2iy6b9fDU8XjadLj4Rxj4TrhuctUtbrAG657_fI-DzgBk=s0-d-e1-ft#https://cloudfilesdm.com/postcards/image-1713281331227.png">
                                          <table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation">
                                            <tbody>
                                              <tr>
                                                <td align="center" valign="top" style="padding:0px 0px 14px 0px">
                                                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;border-spacing:0">
                                                    <tbody>
                                                      <tr>
                                                        <td valign="top" align="center">
                                                          <div style="line-height:143%;letter-spacing:-0.2px;font-family:Arial,Helvetica,sans-serif;font-size:17px;font-weight:normal;font-variant-ligatures:normal;color:#ffffff;text-align:center;text-align-last:center">
                                                            <div><span>Thank you for hauling with US!</span></div>
                                                            <div><span>Please let us know if you have anything else we can help you out with.</span></div>
                                                            <div><span></span></div>
                                                            <div><span>Have a great rest of your day! </span></div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>`;
};
